export default {
      id: "ic_bilyonertv-usage",
      viewBox: "0 0 16 11",
      url: "/" + "images/icons.3.109.2.svg#ic_bilyonertv-usage",
      toString: function () {
        return this.url;
      }
    }